import { ChevronsUpDown } from "lucide-react";
import { useState, type ReactNode, type RefObject } from "react";

import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function ProductPicker({ products, value, onChange, disabled = false }: {
  products: string[];
  value: string | null;
  onChange: (value: string | null) => void;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const pick = (next: string | null) => { onChange(next); setOpen(false); };
  return <PickerShell label="Product" caption={value ?? "All products"} open={open} setOpen={setOpen} disabled={disabled}>
    <Command><CommandInput data-nonmutating placeholder="Search products" /><CommandList>
      <CommandEmpty>No matching product.</CommandEmpty>
      <CommandItem data-nonmutating value="__all__ All products" onSelect={() => pick(null)}>All products</CommandItem>
      {products.map((product) => <CommandItem data-nonmutating key={product} value={product} onSelect={() => pick(product)}>{product}</CommandItem>)}
    </CommandList></Command>
  </PickerShell>;
}

export function PickerShell({ label, caption, open, setOpen, disabled, children, triggerRef }: {
  label: string; caption: string; open: boolean; setOpen: (open: boolean) => void; disabled?: boolean; children: ReactNode; triggerRef?: RefObject<HTMLButtonElement | null>;
}) {
  return <div className="grid min-w-44 gap-1.5">
    <span className="text-[11px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">{label}</span>
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild><Button ref={triggerRef} data-nonmutating type="button" variant="outline" role="combobox" aria-label={label} aria-expanded={open} disabled={disabled} className="justify-between font-normal"><span className="max-w-48 truncate">{caption}</span><ChevronsUpDown aria-hidden className="ml-2 size-4 shrink-0 opacity-50" /></Button></PopoverTrigger>
      <PopoverContent className="w-[min(20rem,calc(100vw-2rem))] p-0" align="start">{children}</PopoverContent>
    </Popover>
  </div>;
}
